module.exports = __webpack_public_path__ + "img/flowchart1.c6c04abb.png";